import ActionButton from '@/components/Reusable/Button/ActionButton';
import ObscuredInput from '@/components/Reusable/Formik/ObscuredInput';
import { Box, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Link from 'next/link';

function LoginForm({
  handleInputChange,
  formData,
  loading,
  handleLoginSubmit,
}) {
  const theme = useTheme();

  return (
    <Box
      component='form'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        alignItems: 'center',
        px: { xs: 2, sm: 4 },
        py: { xs: 3, sm: 4 },
      }}
      onSubmit={(e) => {
        e.preventDefault();
        handleLoginSubmit();
      }}
    >
      <TextField
        variant='outlined'
        onChange={handleInputChange}
        placeholder='Enter your email address'
        label='Email'
        name='email'
        type='email'
        value={formData.email}
        fullWidth
        sx={{
          borderRadius: '12px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            fontSize: 18,
            height: 56,
            p: 0,
            '& fieldset': {
              borderColor: theme.palette.divider,
            },
            '&:hover fieldset': {
              borderColor: 'rgba(145, 158, 171, 0.40)',
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
              borderWidth: 2,
            },
          },
          '& .MuiInputLabel-root': {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightSemiBold,
            fontSize: 16,
          },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset`,
            WebkitTextFillColor: '#000',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        }}
        InputLabelProps={{
          sx: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightSemiBold,
            fontSize: 16,
          },
        }}
      />
      <ObscuredInput
        variant='outlined'
        onChange={handleInputChange}
        placeholder='Enter your password'
        label='Password'
        name='password'
        type='password'
        value={formData.password}
        fullWidth
        sx={{
          borderRadius: '12px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            fontSize: 18,
            height: 56,
            p: 0,
            pr: 2,
            '& fieldset': {
              borderColor: theme.palette.divider,
            },
            '&:hover fieldset': {
              borderColor: 'rgba(145, 158, 171, 0.40)',
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
              borderWidth: 2,
            },
          },
          '& .MuiInputLabel-root': {
            color: theme.palette.primary.main,
            fontSize: 16,
          },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset`,
            WebkitTextFillColor: '#000',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        }}
        InputLabelProps={{
          sx: {
            color: `${theme.palette.text.primary}`,
            fontWeight: theme.typography.fontWeightSemiBold,
            fontSize: 16,
          },
        }}
      />
      <ActionButton
        loading={loading}
        type='submit'
        disabled={!formData.email || !formData.password || loading}
        sx={{ mt: 1 }}
      >
        Log In
      </ActionButton>
      <Box
        component={Link}
        href='/forgot-password'
        sx={{
          marginTop: '.5rem',
          textDecoration: 'none',
          fontWeight: theme.typography.fontWeightSemiBold,
          fontSize: 15,
          alignSelf: 'flex-start',
        }}
      >
        Forgot password?
      </Box>
    </Box>
  );
}

export default LoginForm;
